import { TimezoneDatePipe } from 'lib-trend-core';

const timezoneDate = new TimezoneDatePipe();

function dayOf(at: string | Date, timezone: string): string {
  return timezoneDate.transform(at, 'YYYY-MM-DD', timezone);
}

/** Whether a moment falls on today's calendar day in the company's zone. */
export function isToday(at: string | Date, timezone: string): boolean {
  return dayOf(at, timezone) === dayOf(new Date(), timezone);
}

/** The time of a moment, with its date when it is not from today (RF-21, R-3). */
export function timeLabel(at: string | Date, timezone: string): string {
  return timezoneDate.transform(at, isToday(at, timezone) ? 'HH:mm' : 'DD/MM HH:mm', timezone);
}
